/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [
  {
    action: 'accessAccountId',
    message: messages.SUCCESS_ACCESS_ACCOUNT_ID,
    method: 'POST',
    path: '/account-id/access',
    payloadType: 'boolean',
    requestSchema: requestSchemas.utilities.accessAccountId,
  },
  {
    action: 'accessCustomerId',
    message: messages.SUCCESS_ACCESS_CUSTOMER_ID,
    method: 'POST',
    path: '/customer-id/access',
    payloadType: 'boolean',
    requestSchema: requestSchemas.utilities.accessCustomerId,
  },
  {
    action: 'accessDrawCustomerId',
    message: messages.SUCCESS_ACCESS_DRAW_CUSTOMER_ID,
    method: 'POST',
    path: '/draw-customer-id/access',
    payloadType: 'boolean',
    requestSchema: requestSchemas.utilities.accessDrawCustomerId,
  },
  {
    action: 'accessDrawId',
    message: messages.SUCCESS_ACCESS_DRAW_ID,
    method: 'POST',
    path: '/draw-id/access',
    payloadType: 'boolean',
    requestSchema: requestSchemas.utilities.accessDrawId,
  },
  {
    action: 'accessSystemId',
    message: messages.SUCCESS_ACCESS_SYSTEM_ID,
    method: 'POST',
    path: '/system-id/access',
    payloadType: 'boolean',
    requestSchema: requestSchemas.utilities.accessSystemId,
  },
  {
    action: 'authorizeApiKey',
    message: messages.SUCCESS_AUTHORIZE_API_KEY,
    method: 'POST',
    path: '/api-key/authorize',
    payloadType: 'resource',
    requestSchema: requestSchemas.utilities.authorizeApiKey,
  },
  {
    action: 'checkPermission',
    message: messages.SUCCESS_CHECK_PERMISSION,
    method: 'POST',
    path: '/permission/check',
    payloadType: 'boolean',
    requestSchema: requestSchemas.utilities.checkPermission,
  },
  {
    action: 'getAccessibleAccountIds',
    message: messages.SUCCESS_GET_ACCESSIBLE_ACCOUNT_IDS,
    method: 'GET',
    path: '/accessible-account-ids',
    payloadType: 'collection',
    requestSchema: requestSchemas.utilities.getAccessibleAccountIds,
  },
  {
    action: 'getAccessibleCustomerIds',
    message: messages.SUCCESS_GET_ACCESSIBLE_CUSTOMER_IDS,
    method: 'GET',
    path: '/accessible-customer-ids',
    payloadType: 'collection',
    requestSchema: requestSchemas.utilities.getAccessibleCustomerIds,
  },
  {
    action: 'getAccessibleDrawCustomerIds',
    message: messages.SUCCESS_GET_ACCESSIBLE_DRAW_CUSTOMER_IDS,
    method: 'GET',
    path: '/accessible-draw-customer-ids',
    payloadType: 'collection',
    requestSchema: requestSchemas.utilities.getAccessibleDrawCustomerIds,
  },
  {
    action: 'getAccessibleDrawIds',
    message: messages.SUCCESS_GET_ACCESSIBLE_DRAW_IDS,
    method: 'GET',
    path: '/accessible-draw-ids',
    payloadType: 'collection',
    requestSchema: requestSchemas.utilities.getAccessibleDrawIds,
  },
];
